import { IntegrationType, Region } from 'generated/generated-graphql'

export const IntegrationImages: Record<IntegrationType, string> = {
  [IntegrationType.ParamountLiquor]: '/integrations/paramount-liquor.svg',
  [IntegrationType.VenusAndBooker]: '/integrations/venus-and-booker.svg',
}

type RegionExclusiveWholesalerType = {
  name: string
  logoSrc: string
  logoWidth: number
  logoHeight: number
}

// Regions where every tender, bid and product is pinned to a single wholesaler
export const RegionExclusiveWholesaler: Partial<
  Record<Region, RegionExclusiveWholesalerType>
> = {
  [Region.Australia]: {
    name: 'Paramount Liquor',
    logoSrc: '/paramount_logo.svg',
    logoWidth: 296,
    logoHeight: 143,
  },
  [Region.UnitedKingdom]: {
    name: 'Booker Direct Ltd T/A Best Food Logistic',
    logoSrc: '/integrations/booker-logo.svg',
    logoWidth: 296,
    logoHeight: 48,
  },
}
